<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import { BookMarked, MonitorPlay, School, Podcast, Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()

  import universityPreview from "@images/free/university-preview.jpg"
  let openModal = $state(true)
</script>

<div class="w-full">
  <img
    src={universityPreview}
    class="w-full cursor-not-allowed"
    alt="Preview of a Standard Activity Page"
  />
</div>

<Modal
  closeButton={false}
  hasBackdrop={true}
  allowScroll={true}
  closeOnEsc={true}
  closeOnOuterClick={true}
  bind:open={openModal}
>
  <div class="py-4 px-6">
    <p
      class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl flex justify-start items-center"
    >
      <Lock class="size-7 text-red-800 mr-2" />
      Lead With Purpose University
    </p>
    <p class="mt-6 text-lg/8 text-gray-700">
      The University is not available at your current Free Subscription level.
      Please upgrade to the Standard Subscription to access all the valuable
      features including the following:
    </p>
    <dl class="mt-6 max-w-xl space-y-6 text-base/7 text-gray-600 lg:max-w-none">
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <BookMarked class="size-6 absolute top-1 left-1 text-blue-600" />
          Bookshelf
        </dt>
        <dd class="inline">
          Access our curated library of leadership books and read them together
          with your team. Integration with the Activity Page to track the
          current book and reading progress.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <MonitorPlay class="size-6 absolute top-1 left-1 text-blue-600" />
          Video Library
        </dt>
        <dd class="inline">
          Access a growing library of leadership videos and share them with your
          team to help everyone grow as a leader.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <School class="size-6 absolute top-1 left-1 text-blue-600" />

          Courses
        </dt>
        <dd class="inline">
          Access the Lead with Purpose courses created by Marc Koehler to learn
          the complete Fast Attack Leadership Development System.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <Podcast class="size-6 absolute top-1 left-1 text-blue-600" />

          Surfacing Leadership Podcast
        </dt>
        <dd class="inline">
          Easy access to all the episodes of the Surfacing Leadership Podcast.
        </dd>
      </div>
    </dl>
  </div>
  <div class="py-4 px-8 mt-6 flex justify-end border-t border-gray-200">
    <a
      href={`/plans/${appStore.plan.id}/admin`}
      class="rounded-md bg-green-600 px-3.5 py-2.5 text-base font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
      >Upgrade Now</a
    >
  </div>
</Modal>
